import BaseRepository from './BaseRepository';

class OrganizationRepository extends BaseRepository {
  public getOrganizationsOfCurrentUser(): Promise<any[]> {
    return this.httpClient.get(`/v2/services/round_monitor/organizations`).then((res: any) => res.data.data);
  }

  public getSelectedOrganizationIdFromUrl(): string {
    const result = this.browserHistoryHandler.location.pathname.match(/^\/organizations\/(\d+)\/?$/);
    return result ? result[1] : '';
  }
}

export default OrganizationRepository;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/domain/repository/OrganizationRepository.ts